module.exports = __webpack_public_path__ + "static/Coinex-2017459a6fc1ad68e4ed8d2d06281b26.png";